import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Checkbox,
  Col,
  Grid,
  PageLoader,
  Row,
  TextInput,
  useToggle,
} from '@met/react-components';
import 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ConfirmationModal, PageHeader } from '../../components';
import ApiApplicationTokenModal from '../../components/ApiApplicationTokenModal/ApiApplicationTokenModal';
import history from '../../history';
import { apiApplicationsActions } from '../../store';

const ApiApplication = props => {
  const dispatch = useDispatch();
  const apiApplication = useSelector(
    state => state.apiApplications.application
  );
  const apiApplicationLoading = useSelector(
    state => state.apiApplications.getApiApplication.isLoading
  );
  const applicationId = props.match.params.id;
  const saveIsLoading = useSelector(
    state => state.apiApplications.updateApiApplication.isLoading
  );
  const regenerateIsLoading = useSelector(
    state => state.apiApplications.regenerateApiApplicationToken.isLoading
  );

  const regeneratedToken = useSelector(
    state => state.apiApplications.regeneratedToken
  );

  const [name, setName] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);

  const [isConfirmHidden, toggleIsConfirm] = useToggle(true);
  const [tokenHidden, toggleTokenModel] = useToggle(true);

  useEffect(() => {
    if (apiApplication) {
      setName(apiApplication.name);
      setIsDeleted(apiApplication.isDeleted);
    } else {
      setName('');
      setIsDeleted(false);
    }
  }, [apiApplication, setName, setIsDeleted]);

  // on page load, get the project
  useEffect(() => {
    dispatch(apiApplicationsActions.getSingle(applicationId)).catch(() =>
      toast.error(
        'Something went wrong while retrieving the application. Please try again later.'
      )
    );
  }, [dispatch, applicationId]);

  const handleSaveClicked = useCallback(() => {
    return dispatch(
      apiApplicationsActions.update(applicationId, name, isDeleted)
    )
      .then(() => {
        toast.success('Application Saved');
      })
      .then(() => {
        history.push('/apiApplications');
      });
  }, [dispatch, applicationId, name, isDeleted]);

  const handleConfirmedClicked = useCallback(() => {
    toggleIsConfirm();
    return dispatch(apiApplicationsActions.regenerateToken(applicationId)).then(
      () => {
        toggleTokenModel();
      }
    );
  }, [dispatch, applicationId, toggleIsConfirm, toggleTokenModel]);

  return (
    <div>
      <PageHeader
        title={<Link to={'/apiApplications'}> Applications </Link>}
        subtitle={name}
      />
      {apiApplicationLoading ? (
        <PageLoader />
      ) : (
        <Row>
          <Col xs={12} md={6}>
            <Card>
              <CardHeader>Edit Application</CardHeader>
              <CardBody>
                <label>Name</label>
                <TextInput
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
                <br />
                <Checkbox
                  checked={isDeleted}
                  onCheck={e => setIsDeleted(e.checked)}
                  label={'Is Deleted'}
                />
              </CardBody>
              <CardFooter>
                <Button onClick={toggleIsConfirm} loading={regenerateIsLoading}>
                  {' '}
                  Generate New Token
                </Button>
                <div style={{ marginLeft: 'auto' }}>
                  <Button
                    primary
                    loading={saveIsLoading}
                    onClick={handleSaveClicked}
                  >
                    Save
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardHeader>Information</CardHeader>
              <CardBody>
                <Grid fluid>
                  <Row>
                    <Col>
                      <label>Created By</label>
                      <br />
                      <span
                        style={{
                          paddingLeft: '10px',
                          fontStyle: 'italic',
                          color: 'gray',
                        }}
                      >
                        {apiApplication ? apiApplication.createdBy : ''}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Created</label>
                      <br />
                      <span
                        style={{
                          paddingLeft: '10px',
                          fontStyle: 'italic',
                          color: 'gray',
                        }}
                      >
                        {apiApplication ? (
                          <Moment
                            date={apiApplication.createdAt + 'Z'}
                            fromNow
                            local
                          />
                        ) : (
                          ''
                        )}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Updated By</label>
                      <br />
                      <span
                        style={{
                          paddingLeft: '10px',
                          fontStyle: 'italic',
                          color: 'gray',
                        }}
                      >
                        {apiApplication ? apiApplication.updatedBy : ''}
                      </span>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <label>Updated</label>
                      <br />
                      <span
                        style={{
                          paddingLeft: '10px',
                          fontStyle: 'italic',
                          color: 'gray',
                        }}
                      >
                        {apiApplication ? (
                          <Moment
                            date={apiApplication.updatedAt + 'Z'}
                            fromNow
                            local
                          />
                        ) : (
                          ''
                        )}
                      </span>
                    </Col>
                  </Row>
                </Grid>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
      <ConfirmationModal
        hidden={isConfirmHidden}
        toggle={toggleIsConfirm}
        onConfirm={handleConfirmedClicked}
        title={'Regenerate New Token'}
        body={
          'This will invalidate any previous tokens generated for this application, are you sure?'
        }
      />

      <ApiApplicationTokenModal
        hidden={tokenHidden}
        toggle={toggleTokenModel}
        token={regeneratedToken}
      />
    </div>
  );
};

export default ApiApplication;
